import { Button, FormControlLabel, Radio, RadioGroup, styled, Typography } from "@mui/material";
import { apiChequeChangeStatus } from "api/chequeApi";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

const initialValue = {
  searchText: "",
};

const ChequeStatusContainer = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const chequeStatusRecive = [
  {
    label: "عادی",
    value: "normal",
  },
  {
    label: "در جریان وصول",
    value: "depositReceipt",
  },
  {
    label: "عودت شده",
    value: "receiveRefund",
  },
  {
    label: "وصول شده",
    value: "receiveReceipt",
  },
];
const chequeStatusPaid = [
  {
    label: "عادی",
    value: "normal",
  },
  // {
  //     label: 'در جریان وصول',
  //     value: 'deposit'
  // },
  {
    label: "عودت شده",
    value: "paidRefund",
  },
  {
    label: "پاس شده",
    value: "paidReceipt",
  },
];

export const ChequeChangeStatus = ({
  selectedItem,
  type,
}: {
  selectedItem: number | string;
  type: "received" | "paid";
}) => {
  const dispatch = useDispatch();

  //@ts-ignore
  const { token } = useSelector((state) => state).businessReducer.business;
  const onSubmit = (values: typeof initialValue) => {
    // @ts-ignore
    dispatch(apiChequeChangeStatus(selectedItem, token, values.searchText));
  };
  return (
    <Formik initialValues={initialValue} onSubmit={onSubmit}>
      {(formik) => (
        <Form>
          <ChequeStatusContainer>
            <Typography variant="body1" fontWeight="bold">
              وضعیت چک
            </Typography>
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              name="tableStyle"
              onChange={(event) => {
                formik.setFieldValue("searchText", event.currentTarget.value);
                // @ts-ignore
              }}
            >
              {type === "received" &&
                chequeStatusRecive.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    sx={{ marginLeft: "10px" }}
                    value={item.value}
                    control={<Radio />}
                    label={item.label}
                  />
                ))}
              {type === "paid" &&
                chequeStatusPaid.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    sx={{ marginLeft: "10px" }}
                    value={item.value}
                    control={<Radio />}
                    label={item.label}
                  />
                ))}
            </RadioGroup>
            <Button
              sx={{ marginRight: "20px" }}
              disableRipple
              disableFocusRipple
              disableElevation
              variant="contained"
              type="submit"
            >
              ثبت
            </Button>
          </ChequeStatusContainer>
        </Form>
      )}
    </Formik>
  );
};
